// @flow
import styled from 'styled-components';
import InputTheme from '../../input/theme';
/*::
  import type { Node } from 'react';

  export type TextAreaThemeType = {|
    Main: * => Node,
    TextArea: * => Node,
  |};
*/

var DefaultTheme
/*: TextAreaThemeType */
= {
  Main: styled(InputTheme.Main).withConfig({
    displayName: "theme__Main",
    componentId: "poe332-0"
  })(["min-height:", ";height:auto;"], function (pr) {
    return pr.styledHeight === 'auto' ? '5.6rem' : pr.styledHeight;
  }),
  TextArea: styled(InputTheme.Input).attrs({
    as: 'textarea'
  }).withConfig({
    displayName: "theme__TextArea",
    componentId: "poe332-1"
  })(["height:", ";white-space:normal;overflow:auto;resize:none;"], function (pr) {
    return pr.styledHeight === 'auto' ? '5.6rem' : pr.styledHeight;
  })
};
export default DefaultTheme;